import { useTranslation } from 'react-i18next';

export default function LanguageToggle() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
          i18n.language === 'en'
            ? 'text-slate-900 border-b-2 border-slate-900'
            : 'text-gray-500 hover:text-slate-700'
        }`}
      >
        EN
      </button>
      <span className="text-gray-400">|</span>
      <button
        onClick={() => changeLanguage('id')}
        className={`px-3 py-1 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
          i18n.language === 'id'
            ? 'text-slate-900 border-b-2 border-slate-900'
            : 'text-gray-500 hover:text-slate-700'
        }`}
      >
        ID
      </button>
    </div>
  );
}
